<template>
  <div class="dealer-header">
    <div style="display:flex;flex-direction:row">
      <div style="display:flex;align-items:center;margin-right:20px">
        <pondlogs-logo class="menu-icon" color="#0A2463"></pondlogs-logo>
        &nbsp; &nbsp;
        <span class="nav__header-title">PondLogs</span>
      </div>
    </div>
    <div>
      <el-menu
        class="dealer-menu"
        mode="horizontal"
        :default-active="activeRoute"
        :router="true"
      >
        <el-menu-item index="users" route="/dealer/users">{{
          $t("DL_customers")
        }}</el-menu-item>
        <el-menu-item index="pondmothers" route="/dealer/pondmothers">{{
          $t("Comn_pond_mother")
        }}</el-menu-item>
        <el-menu-item index="pondguards" route="/dealer/pondguards">{{
          $t("Comn_pond_guard")
        }}</el-menu-item>
        <el-menu-item index="shrimptalks" route="/dealer/shrimptalks">{{
          $t("Comn_shrimptalk")
        }}</el-menu-item>
        <el-menu-item index="gateways" route="/dealer/gateways">{{
          $t("Comn_gateway")
        }}</el-menu-item>
      </el-menu>
    </div>
    <div
      style="    display: flex;
    align-items: center;
    justify-content: center;"
    >
      <span>
        <er-dropdown
          @item-click="handleChangeInLanguage"
          trigger="click"
          :listOfItems="langs"
        >
          <template slot="prefix">
            <i class="el-icon-lang">
              <img
                src="../../assets/home/lang-icon.svg"
                height="15"
                width="20,"
              />
            </i>
          </template>
          <template slot="title">
            <p>{{ langSelected }}</p>
          </template>
        </er-dropdown>
      </span>
      &nbsp;
      <span>
        <!-- <a href="/dealer/profile"></a> -->
        <span class="header-user-name">
          {{ getDealerUsername.first_name ? getDealerUsername.first_name : "" }}
        </span>
        <el-divider
          class="user-logout-divider"
          direction="vertical"
        ></el-divider>
        <er-button class="logout-button" @click="logout" type="text">
          <el-row type="flex" :gutter="5">
            <el-col>{{ $t("Comn_logout") }}</el-col>
            <el-col>
              <i class="el-icon-logout">
                <img class="logout-icon" src="@/assets/logout.svg" />
              </i>
            </el-col>
          </el-row>
        </er-button>
      </span>
    </div>
  </div>
</template>

<script>
import pondlogsLogo from "@/components/dashboard/pondlogsLogo";
export default {
  components: {
    pondlogsLogo
  },
  data: function() {
    return {
      langs: { Español: "es", English: "en" },
      revLangs: { es: "Español", en: "English" }
    };
  },
  computed: {
    getDealerUsername() {
      return this.$store.getters["dealer/getDealerProfile"];
    },
    langSelected() {
      return this.revLangs[this.$i18n.locale];
    },
    activeRoute() {
      return this.$route.path.split("/")[2];
    }
  },
  methods: {
    handleChangeInLanguage(value) {
      this.$i18n.locale = value;
      const indexPath = this.$route.meta.langKey;
      const appTitle = document.getElementById("appTitle");
      appTitle.innerHTML = `${this.$t(indexPath)} | PondLogs`;
      localStorage.setItem(`lang`, value);
    },

    async logout() {
      await this.$store.dispatch("auth/dealerSignOut");
      this.$router.push("/");
    },
    async initComponent() {
      try {
        this.loading = true;
        await this.$store.dispatch("dealer/fetchUserProfile");
      } catch (err) {
        console.log(err);
        // this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    }
  },
  async mounted() {
    await this.initComponent();
  }
};
</script>

<style lang="scss">
.dealer-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .nav__header-title {
    @include responsiveProperty(
      font-size,
      $app_font_size_3,
      $app_font_size_xl,
      $app_font_size_xl
    );
    color: #1f2041;
    text-decoration: none;
    font-weight: 500;
  }

  .header-user-name {
    max-width: 200px;
    color: #606266;
    text-transform: capitalize;
    text-decoration: none;
    @include responsiveProperty(
      font-size,
      $app_font_size_1,
      $app_font_size_2,
      $app_font_size_3
    );
  }

  .dealer-menu {
    &.el-menu--horizontal > .el-menu-item {
      height: 44px !important;
      line-height: 44px !important;
    }
  }
  .header-right-user-name {
    max-width: 200px;
    text-transform: capitalize;
    text-decoration: none;
    font-size: 14px;
  }
  .er-dropdown {
    color: #909399;
  }
  .er-dropdown .er-dropdown-trigger__suffix .er-icon-caret {
    color: #909399;
  }

  .er-dropdown .er-dropdown-trigger__suffix {
    margin-left: 10px;
    margin-top: auto;
  }
  .dealer-header .er-dropdown {
    color: #606266;
  }
}
</style>
